import { useSelector } from 'react-redux';
import { PromoterModel } from '@mm/state/model/PromoterModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { chatbotIsActiveOnConnectedPageSelector } from '@mm/state/selectors/viewSelectors';

export const useCustomerChatWidgetPreviews = (promoter?: PromoterModel) => {
  const chatbotIsActiveOnConnectedPage = useSelector(
    chatbotIsActiveOnConnectedPageSelector,
  );
  const { openChatWidgetPreviewModal, openActivateInactiveBotModal } =
    useModalActions();

  const openPreviewModal = () => {
    if (promoter) {
      if (chatbotIsActiveOnConnectedPage) {
        openChatWidgetPreviewModal(promoter);
      } else {
        openActivateInactiveBotModal({
          onBotActivateConfirm: () => {
            openChatWidgetPreviewModal(promoter);
          },
        });
      }
    }
  };
  return { openPreviewModal };
};
